import { api } from './client'
import type { ExceptionReview, ExceptionReviewFilter } from './backofficeQueue'

/* F-105 (TASK-0359): eccezioni dei lead (coda backoffice) e normalizzazione delle fonti. Nessun importo. */

export type LeadExceptionKind =
  | 'Duplicato'
  | 'NumeroNonValido'
  | 'FuoriSla'
  | 'NessunaAttivita'
  | 'FonteSconosciuta'

export const LEAD_EXCEPTION_KIND_LABELS: Record<LeadExceptionKind, string> = {
  Duplicato: 'Duplicato',
  NumeroNonValido: 'Numero non valido',
  FuoriSla: 'Fuori SLA',
  NessunaAttivita: 'Nessuna attività',
  FonteSconosciuta: 'Fonte sconosciuta',
}

export interface LeadExceptionItem {
  leadId: number
  kind: LeadExceptionKind
  label: string
  description: string
  review: ExceptionReview | null
  /** Solo per NumeroNonValido: il numero da correggere. */
  phone: string | null
}

export interface LeadExceptionAggregateRow {
  kind: LeadExceptionKind
  label: string
  affectedLeads: number
}

export interface LeadExceptionsResponse {
  type: string | null
  limit: number
  aggregate: LeadExceptionAggregateRow[]
  ignoredCount: number
  review: string | null
  total: number
  hasMore: boolean
  count: number
  items: LeadExceptionItem[]
}

export interface LeadSourceNormalizationItem {
  raw: string
  count: number
  suggestedCode: string | null
}

export interface LeadSourceOption {
  code: string
  label: string
}

export interface LeadSourceNormalizationPreview {
  items: LeadSourceNormalizationItem[]
  emptyCount: number
  allowed: LeadSourceOption[]
}

export interface LeadSourceNormalizationResult {
  updated: number
  results: { code: string; count: number }[]
}

export const leadExceptionsApi = {
  list: (p: { type?: string; review?: ExceptionReviewFilter; limit?: number } = {}) => {
    const q = new URLSearchParams()
    if (p.type) q.set('type', p.type)
    if (p.review) q.set('review', p.review)
    if (p.limit) q.set('limit', String(p.limit))
    return api<LeadExceptionsResponse>(`/api/leads/exceptions?${q}`)
  },

  review: (leadId: number, body: { kind: LeadExceptionKind; decision: 'presa_in_carico' | 'ignorata'; note?: string }) =>
    api<unknown>(`/api/leads/${leadId}/exceptions/review`, { method: 'POST', body: JSON.stringify(body) }),

  reopen: (leadId: number, kind: LeadExceptionKind) =>
    api<void>(`/api/leads/${leadId}/exceptions/review?kind=${encodeURIComponent(kind)}`, { method: 'DELETE' }),

  sourcePreview: () => api<LeadSourceNormalizationPreview>('/api/leads/source-normalization'),

  sourceApply: (mappings: { raw: string; code: string }[]) =>
    api<LeadSourceNormalizationResult>('/api/leads/source-normalization', {
      method: 'POST',
      body: JSON.stringify({ mappings }),
    }),
}
